import { GripVertical } from "lucide-react"

import { Icon, IconSizes } from "../../../../components/Icon"
import { classNames } from "../../../../lib/classNames"
import { useSortableRow } from "../../SortableRows/SortableRowsProvider"
import { TableCell, TableCellProps, TableCellWidth } from "../TableCell"

export interface TableDragHandleCellProps
  extends Omit<TableCellProps, "children" | "width"> {
  rowKey: string
}

export function TableDragHandleCell({
  className,
  rowKey,
  ...otherProps
}: TableDragHandleCellProps) {
  const { dragHandleProps } = useSortableRow({ id: rowKey })

  return (
    <TableCell
      width={TableCellWidth.ExtraExtraSmall}
      onClick={(e) => e.stopPropagation()}
      className={classNames("cursor-default border-r-0", className)}
      {...dragHandleProps}
      {...otherProps}
    >
      <Icon
        icon={GripVertical}
        size={IconSizes.ExtraSmall}
        className="color-icon-subtle cursor-grab"
      />
    </TableCell>
  )
}
